module.exports = __webpack_public_path__ + "static/media/social-media-marketing.a04ee9e0.svg";